import moment from 'moment';

function parseDate(value) {
  if (!value) {
    return moment.invalid();
  }

  if (moment(value, 'DD/MM/YYYY', true).isValid()) {
    return moment(value, 'DD/MM/YYYY', true);
  }

  return moment(value);
}

export function validateIntervalOfDate(startDate, endDate) {
  const parsedStartDate = parseDate(startDate);
  const parsedEndDate = parseDate(endDate);

  if (!parsedStartDate.isValid() || !parsedEndDate.isValid()) {
    return {
      valid: false,
      message: 'Preencha os campos de data',
    };
  }

  if (parsedStartDate.isAfter(parsedEndDate, 'day')) {
    return {
      valid: false,
      message: 'Data inicial não pode ser maior que data final',
    };
  }

  if (parsedEndDate.diff(parsedStartDate, 'days') > 60) {
    return {
      valid: false,
      message: 'Período máximo de 60 dias',
    };
  }

  return {
    valid: true,
  };
}
